<template>
  <div class="looking_site">
    <van-sticky>
      <van-nav-bar title="帮我找场地" left-arrow @click-left="goback()" />
    </van-sticky>

    <div class="site_form">
      <van-form
        label-width="60"
        :show-error="false"
        @submit="onSubmit"
        error-message-align="right"
      >
        <van-cell-group>
          <van-field
            input-align="right"
            required
            v-model="submitData.contactName"
            label="姓名"
            placeholder="请输入"
            is-link
            :rules="[{ required: true, message: '请输入姓名' }]"
          />

          <van-field
            is-link
            input-align="right"
            required
            type="number"
            v-model="submitData.contactNumber"
            label="电话"
            placeholder="请输入"
            :rules="[
              { required: true, message: '请输入电话' },
              { pattern: /^1[3456789]\d{9}$/, message: '电话格式错误！' },
            ]"
          />

          <van-field
            input-align="right"
            required
            type="number"
            v-model="submitData.area"
            label="需求面积"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入需求面积' }]"
          >
            <template #extra> ㎡</template>
          </van-field>

          <van-field
            input-align="right"
            required
            v-model="fieldValue"
            is-link
            readonly
            label="意向区域"
            placeholder="请选择意向区域"
            @click="showCascader = true"
            :rules="[{ required: true, message: '请选择意向区域' }]"
          />

          <van-field
            input-align="right"
            required
            is-link
            v-model="submitData.priceRange"
            label="价格区间"
            placeholder="请输入价格区间（如2000-4000）"
            :rules="[{ required: true, message: '请输入价格区间' }]"
          >
            <template #extra>元</template>
          </van-field>

          <van-field
            input-align="right"
            required
            v-model="submitData.type_name"
            label="类型"
            readonly
            placeholder="请选择"
            is-link
            @click="showType = true"
          />

          <van-field
            input-align="right"
            required
            v-model="submitData.register_name"
            label="注册"
            readonly
            placeholder="请选择"
            is-link
            @click="showRegister = true"
          />

          <div class="form_feature">
            <div class="fs14">
              场地特色(多选)
              <!-- <span
                style="font-size: 8px; color: red"
                v-if="submitData.siteCharacteristics.length === 0"
                >*必须选中一项</span
              > -->
            </div>
            <div class="feature_list">
              <van-button
                native-type="button"
                :color="item.check ? '#195ED7' : '#c3c3c3'"
                v-for="(item, index) in siteCharacteristicsOptions"
                :key="index"
                @click="changeSiteOpentions(index)"
                >{{ item.name }}</van-button
              >
            </div>
          </div>

          <van-field
            v-model="submitData.remark"
            rows="2"
            autosize
            label="备注"
            type="textarea"
            maxlength="200"
            placeholder="请检单描述你的需求"
            show-word-limit
          />
        </van-cell-group>

        <div class="form_btn">
          <van-button
            round
            block
            color="#195ED7"
            type="info"
            native-type="submit"
            :loading="isLoading"
            loading-text="正在提交ing..."
            >立即提交</van-button
          >
        </div>
      </van-form>
    </div>

    <van-popup v-model="showCascader" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        @close="showCascader = false"
        @finish="onFinish"
        :field-names="{
          text: 'name',
          value: 'area_code',
          children: 'children',
        }"
      />
    </van-popup>

    <van-action-sheet
      v-model="showType"
      :actions="typeOptions"
      @select="onSelectType"
    />
    <van-action-sheet
      v-model="showRegister"
      :actions="registerOptions"
      @select="onSelectRegister"
    />
  </div>
</template>

<script>
import cityData from "@/assets/js/city.js";
import { Button } from "vant";
import { NavBar } from "vant";
import { Form, Field, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { ActionSheet, Cascader, Popup, Notify } from "vant";

export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
  },
  data() {
    return {
      submitData: {
        contactName: "",
        contactNumber: "",
        area: "",
        province: "",
        city: "",
        district: "",
        priceRange: "",
        type: "",
        type_name: "",
        register: "",
        register_name: "",
        siteCharacteristics: "",
        remark: "",
      },
      isLoading: false,
      showPicker: false,
      showType: false,
      typeOptions: [
        { name: "租房", type: 1 },
        { name: "二手房", type: 2 },
      ],
      showRegister: false,
      registerOptions: [
        { name: "可注册", type: 1 },
        { name: "不可注册", type: 2 },
      ],
      showCascader: false,
      cascaderValue: "",
      fieldValue: "",

      // 选项列表，children 代表子选项，支持多级嵌套
      options: [],

      siteCharacteristicsOptions: [
        { name: "纯写字楼", type: 1, check: false },
        { name: "新房", type: 2, check: false },
      ],
    };
  },

  //初始化加载
  created() {
    this.options = cityData.data;
    this.getDetailInfo();
  },

  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      var info = selectedOptions.map((option) => option.name);
      this.fieldValue = selectedOptions.map((option) => option.name).join("/");
      this.submitData.province = info[0];
      this.submitData.city = info[1];
      this.submitData.district = info[2];
      this.showCascader = false;
    },

    // 选中类型
    onSelectType(item) {
      this.showType = false;
      this.submitData.type_name = item.name;
      this.submitData.type = item.type;
    },

    // 选中注册
    onSelectRegister(item) {
      this.submitData.register_name = item.name;
      this.submitData.register = item.type;
      this.showRegister = false;
    },

    //选中场地特色
    changeSiteOpentions(index) {
      this.siteCharacteristicsOptions[index].check =
        !this.siteCharacteristicsOptions[index].check;
      var data = this.siteCharacteristicsOptions.filter(
        (item) => item.check === true
      );
      this.submitData.siteCharacteristics = data
        .map((option) => option.type)
        .join(",");
    },

    onSubmit() {
      var that = this;
      //if (that.submitData.siteCharacteristics.length > 0) {
        that.isLoading = true;
        //帮我找场地-保存
        that.$api
          .demandSaveAPI(that.submitData)
          .then(function (res) {
            if (res.data.code === 200) {
              Notify({
                type: "success",
                message: "提交成功！",
                onClose() {
                  that.isLoading = false;
                  that.$router.push({ name: "SubmitLookingSite" });
                },
              });
            }
          })
          .catch(function (err) {
            console.log("error");
            that.isLoading = false;
          });
      //}
    },
    //获取其他信息
    getDetailInfo() {
      let that = this;
      //帮我找场地-保存
        that.$api
          .demanAddAPI()
          .then(function (res) {
            if (res.data.code === 200) {
              console.log(res);
              that.registerOptions = [];
              that.typeOptions = [];
              that.siteCharacteristicsOptions = [];
              for(var i = 0; i < res.data.data.registerList.length; i++){
                that.registerOptions.push({'name':res.data.data.registerList[i].itemText,'type':res.data.data.registerList[i].itemId})
              }
              for(var i = 0; i < res.data.data.typeList.length; i++){
                that.typeOptions.push({'name':res.data.data.typeList[i].itemText,'type':res.data.data.typeList[i].itemId})
              }
              for(var i = 0; i < res.data.data.siteCharacteristicsList.length; i++){
                that.siteCharacteristicsOptions.push({'check': false,'name':res.data.data.siteCharacteristicsList[i].itemText,'type':res.data.data.siteCharacteristicsList[i].itemId})
              }
            }
          })
          .catch(function (err) {
            console.log("error");
            that.isLoading = false;
          });
    },
  },
};
</script>

<style lang="less" scoped>
.looking_site {
  display: flex;
  flex-direction: column;

  .site_form {
    padding: 0px 10px;
    height: auto;

    .form_tag {
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
    }

    .van-cell {
      display: flex;
      align-items: flex-start;
    }

    .form_feature {
      color: #646566;
      margin: 15px 10px;

      .fs28::after {
        position: absolute;
        left: 220px;
        color: #ee0a24;
        margin-top: 5px;
        font-size: 8px;
        content: "*";
      }

      .van-button {
        height: 35px;
        margin-top: 15px;
        margin-right: 15px;
      }
    }
  }

  .form_btn {
    margin: 40px 10px;
    border-radius: 1000px;
    box-shadow: 0px 5px 8px rgba(25, 94, 215, 0.5);

    .van-button {
      height: 44px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/home/lookingSite.vue